import { Workflow, Megaphone, PauseCircle, Clock } from "lucide-react";

const META = {
  automation: { label: "Automazione", color: "#8B5CF6", icon: Workflow },
  wait: { label: "Automazione · fine attesa", color: "#8B5CF6", icon: Clock },
  campaign: { label: "Campagna", color: "#F59E0B", icon: Megaphone },
  pause_end: { label: "Bentornato fine pausa", color: "#F59E0B", icon: PauseCircle },
};

export function originMeta(origin) {
  return (origin && META[origin.type]) || null;
}

export function OriginCaption({ origin, id }) {
  const meta = originMeta(origin);
  if (!meta) return null;
  const Icon = meta.icon;
  let text = "";
  if (origin.type === "automation" || origin.type === "wait") {
    text = `«${origin.automation_name || "?"}»` + (origin.step_text ? ` · nodo «${origin.step_text}${origin.step_text.length >= 60 ? "…" : ""}»` : origin.step_key ? ` · nodo ${origin.step_key}` : "");
    if (origin.template) text += ` · template ${origin.template}`;
  } else if (origin.type === "campaign") {
    text = `«${origin.campaign_name || "?"}»` + (origin.template ? ` · template ${origin.template}` : "");
  } else if (origin.type === "pause_end") {
    text = origin.template ? `template ${origin.template}` : "";
  }
  return (
    <p className="text-[10px] mt-1 flex items-center gap-1 flex-wrap" style={{ color: meta.color }} data-testid={`chat-origin-${id}`} title="Origine dell'invio automatico">
      <Icon className="h-3 w-3 shrink-0" /> <span className="font-semibold">{meta.label}</span> <span className="text-slate-300/80">{text}</span>
      {origin.path?.length > 1 && <span className="text-slate-400/70">· percorso {origin.path.join(" → ")}</span>}
    </p>
  );
}
